module.exports = __webpack_public_path__ + "static/media/townhall_columnists_waynegrudem_2016_07_28_why-voting-for-donald-trump-is-a-morally-good-choice-n2199564_plot.68e9561a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/townhall_columnists_waynegrudem_2016_07_28_why-voting-for-donald-trump-is-a-morally-good-choice-n2199564_plot.png
// module id = 426
// module chunks = 0